import {
  DECIMAL_INPUT_PROPS,
  IOS_SAFE_INPUT_CLASS,
  IOS_SAFE_INPUT_COMPACT_CLASS,
} from '@constants/inputConstants'

/**
 * The single numeric text field used by every betting card.
 *
 * It only adds BEHAVIOUR — the decimal-keypad attributes and the class that
 * carries the iOS 16px font-size floor (see styles/base/_iosSafeInput.scss).
 * Layout and colours stay with the caller's own class, which is applied last so
 * it keeps winning the cascade exactly as it did before this component existed.
 *
 * `compact` opts into trimmed side padding, for boxes too narrow to hold 16px
 * glyphs at their designed padding.
 *
 * Any numeric field added in future should use this component; one that forgets
 * is still caught by the passive layer-2 net in the same stylesheet.
 *
 * `ref` arrives through `...props` (React 19 passes it as a normal prop for
 * function components), so no forwardRef wrapper is needed.
 */
const NumericInput = ({ className = '', compact = false, ...props }) => {
  const classes = [IOS_SAFE_INPUT_CLASS, compact && IOS_SAFE_INPUT_COMPACT_CLASS, className]
    .filter(Boolean)
    .join(' ')

  // Defaults first, caller's props second, so a call site can still override
  // any attribute (e.g. a different inputMode) if it ever needs to.
  return <input {...DECIMAL_INPUT_PROPS} {...props} className={classes} />
}

export default NumericInput
